export default __webpack_public_path__ + "static/media/Trinket of the Earth Mother.15c4623a.jpg";